import { render, staticRenderFns } from "./ServiceOne.vue?vue&type=template&id=66d74e52&scoped=true&"
import script from "./ServiceOne.vue?vue&type=script&lang=js&"
export * from "./ServiceOne.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOne.vue?vue&type=style&index=0&id=66d74e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d74e52",
  null
  
)

export default component.exports